export default __webpack_public_path__ + "static/media/loan_n.375602ef.svg";